import {UI} from "../../../../../../stem-core/src/ui/UIBase";
import {styleRule, StyleSheet} from "../../../../../../stem-core/src/ui/Style";

import {NOOP_FUNCTION} from "../../../../../../stem-core/src/base/Utils";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {Messages} from "../../../../../Messages";
import {ActiveCardInfo} from "../../../../../common/ActiveCardInfo";
import {isSmallScreen} from "../../../../../UtilsLib";
import {panelChildMargin} from "../../../../../StyleConstants";


class UsingCardComponentStyle extends StyleSheet {
    @styleRule
    title = this.themeProps.PANEL_TITLE;

    @styleRule
    element = {
        display: "flex",
        justifyContent: "space-between",
        ">:not(:last-child)": {
            marginBottom: panelChildMargin,
        }
    }

    @styleRule
    link = {
        ...this.themeProps.PANEL_LINK,
        alignSelf: "center",
    };

    @styleRule
    usingCard = {
        display: "flex",
        justifyContent: "space-between",
        ">*>*": {
            alignSelf: "center",
        }
    };
}

@registerStyle(UsingCardComponentStyle)
export class UsingCardComponent extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            card: null,
            onChangeCard: NOOP_FUNCTION,
            hideTitle: false,
            changeCardMessage: Messages.cardComponentUseAnother,
        }
    }

    isValid() {
        return true;
    }

    getPaymentMethodId(scope, callback) {
        callback(this.options.card?.id);
    }

    render() {
        const {styleSheet} = this;
        const {card, onChangeCard, changeCardMessage, hideTitle} = this.options;

        return [
            hideTitle ? null : <div className={styleSheet.title}>{Messages.cardComponentTitle}</div>,
            <div className={styleSheet.usingCard}>
                <ActiveCardInfo card={card}/>
                <div className={styleSheet.link} onClick={onChangeCard}>{changeCardMessage}</div>
            </div>
        ]
    }
}
